export enum OptimizelyFeatureFlags {
    CLEAR_CACHE_ON_FLAGS_CHANGE = 'clear_cache_on_flags_change',
    HEADLINE_RIBBON_ENABLED = 'headline_ribbon_enabled',
    JJ_ADVISORY_MESSAGE_ENABLED = 'ace-83',
    REJOIN_JOURNEY = 'rejoin_journey',
    MEMBERSHIP_TERMS_VISIBILITY = 'tcb-52',
    SHORTEN_MBT_PRICE_DRAW_TEST = 'tcb-54',
    PAYMENT_IN_ARREARS = 'payment_in_arrears',
    PURGE_ALL_CACHE_TRIGGER = 'purge_all_cache_trigger',
    PURGE_CACHE_BY_AMPLIENCE_TEST_FLAG = 'purge_cache_by_amplience_test_flag',
    PURGE_CACHE_BY_URL_TEST_FLAG = 'purge_cache_by_url_test_flag',
    RENEWALS_ENABLED = 'renewals_enabled',
    SUPPORT_CENTRE_ENABLED = 'support_centre_enabled',
    AA_TEST = 'tcb-51',
    GUEST_PASS_ENABLED = 'guest_pass_enabled',
    GUEST_PASS_SLOTS_USAGE_ENABLED = 'guest_pass_slots_usage_enabled',
    RENEWAL_UPSELL_ENABLED = 'renewal_upsell_enabled',
    MULTIPLE_ADD_ONS_ENABLED = 'multiple_add_ons_enabled',
    SAVINGS_VISIBILITY_VARIATIONS = 'tcb-48',
    API_VERSION_3_ENABLED = 'api_version_3_enabled',
    YOUR_PAYMENTS_BUTTON_VARIATIONS = 'tcb-45',
    USE_OPTIMIZELY_REACT_SDK = 'use_optimizely_react_sdk',
    PAYPAL_PAY_IN_3_PRODUCT_OPTIONS = 'paypal_pay_in_3_product_options',
    PAYPAL_PAY_IN_3_TABLE_IFRAME = 'paypal_pay_in_3_table_iframe',
    PRODUCT_TABLE_FREE_FREEZE_NOTICE = 'product_table_free_freeze_notice',
    RETURN_USER_BASKET = 'return_user_basket',
    PAYPAL_PAY_IN_3_GYM_BAG_IFRAME = 'paypal_pay_in_3_gym_bag_iframe',
    PINO_TABLE_MBT_OPTIMIZATION = 'pino_table_mbt_optimization',
    PAYPAL_PAY_IN_3_JOIN_JOURNEY_ENABLED = 'paypal_pay_in_3_join_journey_enabled',
    PAYPAL_RENEWAL_ENABLED = 'paypal_renewal_enabled',
    PAYPAL_PAY_IN_3_RENEWAL_ENABLED = 'paypal_pay_in_3_renewal_enabled',
    MEMBER_API_VERSION_3_ENABLED = 'member_api_version_3_enabled',
    MBT_PRICE_DRAWER_OPTIMISATION = 'tcb-69-mbt-price-drawer-optimisation',
    TCB65_MAP_V_NO_MAP = 'tcb65_map_v_no_map',
    MULTIPLE_ADD_ONS_PHASE_2_ENABLED = 'multiple_add_ons_phase_2_enabled',
}
